export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/ranking/icon-help-light-2e55e42a8704c377e816610e431cfa6d.svg";